var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenSpiral(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 226,
    viewBox: "0 0 226 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8687 168.152C18.5171 148.693 17.3463 123.687 23.7922 99.7174C30.2381 75.7475 45.4269 52.5023 67.2916 38.9865C89.1563 25.4707 115.41 22.4102 139.289 28.2526C163.168 34.0951 186.141 48.8701 198.332 68.0589C210.522 87.2477 212.26 105.033 201.88 124.739C191.671 144.615 172.734 153.058 151.61 160.892C130.487 168.726 109.348 187.269 86.2701 190.354C63.192 193.438 45.2203 187.611 31.8687 168.152Z",
    stroke: "url(#paint0_linear)",
    strokeWidth: 1.2857,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4296 163.235C28.2431 146.099 28.1028 124.511 33.6995 103.109C39.2962 81.7083 53.0542 60.3836 72.7014 48.0724C92.3147 35.8639 115.598 32.847 137.119 37.9101C158.641 42.9732 178.777 56.0124 189.972 72.7069C201.168 89.4013 201.4 105.207 192.995 121.691C184.589 138.174 164.497 149.768 147.428 152.56C130.36 155.352 109.604 178.238 88.7119 181.59C67.9561 184.872 52.5822 180.474 40.4296 163.235Z",
    stroke: "url(#paint1_linear)",
    strokeWidth: 1.2857,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1307 158.588C38.5187 143.568 38.3843 125.402 43.4733 106.568C48.5624 87.7346 60.6506 68.3654 77.9439 57.3276C95.2372 46.2898 115.652 43.3505 134.577 47.6692C153.502 51.988 171.415 62.8104 181.207 77.5592C190.999 92.308 191.532 104.452 183.227 119.601C174.921 134.75 158.848 140.378 142.571 146.965C126.295 153.551 108.908 169.687 91.1228 172.926C73.3038 176.268 59.6402 173.574 49.1307 158.588Z",
    stroke: "url(#paint2_linear)",
    strokeWidth: 1.2857,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6573 154.108C48.5519 141.41 48.5934 126.151 53.1747 109.885C57.6535 93.5853 68.038 76.2744 83.0113 66.4072C97.9846 56.5401 115.873 53.6774 132.201 57.2517C148.53 60.8261 163.946 69.5695 172.436 82.0644C180.927 94.5592 181.389 104.856 174.035 117.47C166.681 130.084 152.692 136.287 138.736 142.388C124.781 148.488 108.549 161.13 93.7354 164.668C78.8877 168.307 66.7628 166.807 57.6573 154.108Z",
    stroke: "url(#paint3_linear)",
    strokeWidth: 1.2857,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3915 149.707C58.4171 139.434 59.2489 126.944 62.9471 113.349C66.7817 99.6861 75.5304 84.228 88.1498 75.6343C100.872 67.0744 116.028 64.2204 129.999 67.0154C143.97 69.8104 156.343 76.066 163.805 86.5114C171.267 96.9567 171.249 105.613 165.189 116.375C159.13 127.137 146.574 132.789 135.247 138.504C123.783 144.289 108.948 154.771 96.5912 157.411C84.2345 160.051 74.3319 160.083 66.3915 149.707Z",
    stroke: "url(#paint4_linear)",
    strokeWidth: 1.2857,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8172 144.858C68.2809 136.77 69.733 127.562 72.8896 116.638C76.0461 105.714 83.2269 91.9028 93.5263 84.4798C103.826 77.0568 116.387 74.4848 127.898 76.1244C139.408 77.764 149.388 82.6588 155.447 91.1585C161.506 99.6582 161.416 106.467 156.446 115.31C151.476 124.153 141.207 129.762 131.826 135.095C122.445 140.429 109.551 148.134 99.4812 150.39C89.4118 152.646 81.251 152.911 74.8172 144.858Z",
    stroke: "url(#paint5_linear)",
    strokeWidth: 1.2857,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1744 139.86C78.0755 133.616 79.5677 127.726 82.3529 119.301C85.1382 110.875 90.5128 99.0888 98.3558 92.9053C106.233 86.619 116.507 84.0886 125.626 85.0516C134.745 86.0146 142.229 89.5146 147.226 96.0675C152.121 102.587 151.823 107.959 148.011 115.019C144.198 122.079 136.013 127.58 128.645 131.982C121.277 136.385 110.599 142.202 102.679 143.801C94.7601 145.4 88.3073 146.002 83.1744 139.86Z",
    stroke: "url(#paint6_linear)",
    strokeWidth: 1.2857,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3257 134.474C87.4931 129.902 88.7487 125.416 90.6842 119.217C92.6197 113.019 97.5915 105.202 103.149 100.429C108.673 95.758 116.59 93.1324 123.25 93.6243C129.909 94.1162 135.411 96.0487 139.039 100.895C142.667 105.742 142.469 109.78 139.678 115.126C136.99 120.506 130.886 125.213 125.429 128.652C119.971 132.09 111.885 136.256 105.946 137.37C99.8696 138.553 95.1582 139.047 91.3257 134.474Z",
    stroke: "url(#paint7_linear)",
    strokeWidth: 1.2857,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.978 130.957C104.984 131.688 101.877 131.8 99.3105 128.901C96.7783 125.898 97.5244 122.953 98.8491 118.946C100.208 114.836 103.443 109.865 107.262 106.91C111.082 103.956 116.132 102.092 120.605 101.975C125.078 101.858 128.461 102.976 130.925 106.184C133.389 109.393 133.189 112.062 131.42 115.694C129.651 119.326 125.764 122.829 122.046 125.133C118.328 127.437 113.04 130.362 108.978 130.957Z",
    stroke: "url(#paint8_linear)",
    strokeWidth: 1.2857,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 194.494,
    y1: 57.6899,
    x2: 19.1797,
    y2: 145.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC5BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 198.753,
    y1: 91.861,
    x2: 27.0982,
    y2: 120.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C6AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#208FE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 187.053,
    y1: 121.401,
    x2: 42.3889,
    y2: 102.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBC797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F9AC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 165.549,
    y1: 138.74,
    x2: 59.7726,
    y2: 91.2241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1C882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FA5AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 144.022,
    y1: 142.938,
    x2: 76.98,
    y2: 85.1798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8CA6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FB18E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 128.283,
    y1: 138.892,
    x2: 93.0681,
    y2: 84.0079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECB5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EBC73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 121.224,
    y1: 139.345,
    x2: 106.28,
    y2: 87.1265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CC46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEC757"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 114.882,
    y1: 139.173,
    x2: 115.688,
    y2: 92.8305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BACD31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDD23C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 109.651,
    y1: 134.185,
    x2: 120.871,
    y2: 100.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0CE1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDDD20"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenSpiral);
export default __webpack_public_path__ + "static/media/GreenSpiral.9ff6db75567243b0efc642134c7a052e.svg";
export { ForwardRef as ReactComponent };